/* =========================================================================
   IL CASSETTO DEL CARRELLO
   =========================================================================
   Si riempie da /cart.js, quindi resta giusto anche quando aggiunge
   Kaching Bundles o il form della scheda. Si apre da solo dopo ogni
   aggiunta: e' il comportamento dello store originale.

   Se il JavaScript non parte, i form funzionano lo stesso: il pulsante fa
   il POST normale e si finisce sulla pagina /cart.

   NOTA: l'apertura NON usa requestAnimationFrame. Se la pagina non sta
   disegnando i fotogrammi (scheda in secondo piano, browser headless),
   rAF non scatta mai e il cassetto resterebbe fuori schermo pur essendo
   "aperto". Si forza il reflow e si aggiunge subito la classe: la
   transizione parte lo stesso e non dipende dal compositore.

   20/08/2026 — DUE RIPARAZIONI DI LINGUA
   1. Le chiamate al carrello partivano da "/cart.js" senza il prefisso
      della lingua: Shopify rispondeva SEMPRE in italiano, e nel cassetto
      francese comparivano i titoli italiani ("CM Complex — Kit Viso").
      Adesso passano da radice(), che vale "/" in italiano e "/fr/" in
      francese.
   2. Le frasi scritte a mano qui dentro ("Il carrello e' vuoto.",
      "Aggiungo…", le etichette dei pulsanti +/-) restavano in italiano in
      tutte le lingue, perche' il JavaScript non passa dal filtro di
      traduzione di Liquid. Adesso arrivano da window.CM_T, che riempie
      layout/theme.liquid; l'italiano resta come rete di sicurezza.

   28/08/2026 — I SEI PEZZI DEL VECCHIO CASSETTO SHRINE
   Rimessi: conteggio nell'intestazione, timer di 5 minuti, prezzo pieno
   barrato con "Risparmi" sulla riga, "Risparmi" nel totale, prezzo dentro
   il pulsante di pagamento, pulsante per togliere la riga.
   I dati ci sono gia' tutti in /cart.js: gli sconti dei pacchetti Kaching
   sono sconti automatici lato server, quindi original_line_price,
   final_line_price e total_discount arrivano gia' calcolati. Non serve
   nessuna app e nessun canone.

   ⚠️ I soldi si scrivono col formato del negozio (shop.money_format), non
   con "€ " scritto a mano: il cassetto diceva "€ 68,40" mentre tutto il
   resto del sito dice "€68,40".

   ⚠️ Questo file e' l'UNICO che gestisce il cassetto. In main.js c'era una
   copia piu' vecchia dello stesso codice: due ascoltatori sullo stesso
   form volevano dire DUE pezzi nel carrello per un clic solo. La copia
   vecchia e' stata tolta. Se un giorno serve rimetterci mano, si tocca
   qui e basta.
   ========================================================================= */
(function () {
  var cassetto = document.querySelector('[data-cassetto]');
  var velo     = document.querySelector('[data-cassetto-velo]');
  if (!cassetto || !velo) return;

  var corpo       = cassetto.querySelector('[data-cassetto-corpo]');
  var piede       = cassetto.querySelector('[data-cassetto-piede]');
  var totale      = cassetto.querySelector('[data-cassetto-totale]');
  var contaTesta  = cassetto.querySelector('[data-cassetto-conta-testa]');
  var contaN      = cassetto.querySelector('[data-cassetto-conta-n]');
  var contaParola = cassetto.querySelector('[data-cassetto-conta-parola]');
  var risparmi    = cassetto.querySelector('[data-cassetto-risparmi]');
  var risparmiVal = cassetto.querySelector('[data-cassetto-risparmi-val]');
  var pagaPrezzo  = cassetto.querySelector('[data-cassetto-paga-prezzo]');
  var fasciaTimer = cassetto.querySelector('[data-cassetto-timer]');
  var etiTimer    = cassetto.querySelector('[data-cassetto-timer-eti]');
  var etiRisparmi = cassetto.querySelector('[data-cassetto-risparmi-eti]');
  var oraTimer    = cassetto.querySelector('[data-cassetto-timer-ora]');

  var ultimoFuoco = null;
  var timerChiusura = null;
  var battito = null;                    /* l'intervallo del conto alla rovescia */
  var MINUTI = 5 * 60 * 1000;            /* nel vecchio Shrine erano 300 secondi */
  var CHIAVE_SCADENZA = 'cm_scadenza';

  /* Le due etichette del cassetto arrivano dal Liquid (window.CM_T) invece
     che dal markup: le cinque frasi nuove di questo giro non stanno nei
     file di lingua ma in layout/theme.liquid. Si scrivono una volta sola,
     all'avvio, perche' la lingua della pagina non cambia sotto i piedi. */
  function scriviEtichette() {
    if (etiTimer)    etiTimer.textContent    = T('riservatoPer', 'Riservato per');
    if (etiRisparmi) etiRisparmi.textContent = T('risparmi', 'Risparmi');
  }

  /* la radice della lingua: "/" in italiano, "/de/" in tedesco */
  function radice() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* le frasi tradotte arrivano dal Liquid; il secondo argomento e' il ripiego */
  function T(chiave, ripiego) {
    return (window.CM_T && window.CM_T[chiave]) || ripiego;
  }

  /* ---------------------------------------------------------------------
     DUE PULIZIE DIVERSE, E NON VANNO SCAMBIATE
     esc()  — per i DATI che arrivano da /cart.js (titoli prodotto, nomi
              degli sconti, chiavi, indirizzi immagine). Escape completo:
              e' roba che non abbiamo scritto noi e finisce in innerHTML.
     attr() — per le FRASI TRADOTTE che arrivano dal Liquid via CM_T.
              Qui si tocca solo la virgoletta doppia, che chiuderebbe
              l'attributo. Un escape completo sarebbe un danno: l'italiano
              nei file di lingua usa le entita' HTML ("Il carrello &egrave;
              vuoto."), e passandole da esc() si leggerebbe in pagina
              "Il carrello &egrave; vuoto." con l'entita' in chiaro.
     --------------------------------------------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function attr(s) {
    return String(s == null ? '' : s).replace(/"/g, '&quot;');
  }

  /* ---------------------------------------------------------------------
     I SOLDI, COL FORMATO DEL NEGOZIO
     Shopify tiene il formato in shop.money_format e usa dei segnaposto.
     Prima qui c'era "€ " + numero scritto a mano: sbagliava lo spazio
     rispetto al resto del sito, e su un negozio in piu' valute avrebbe
     scritto euro anche dove non lo sono.
     --------------------------------------------------------------------- */
  function separa(numero, decimali, migliaia, virgola) {
    var n = (numero / 100).toFixed(decimali);
    var parti = n.split('.');
    var interi = parti[0].replace(/\B(?=(\d{3})+(?!\d))/g, migliaia);
    return decimali > 0 ? interi + virgola + parti[1] : interi;
  }

  function soldi(centesimi) {
    var f = T('formatoSoldi', '€{{amount_with_comma_separator}}');
    var c = centesimi || 0;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, nome) {
      switch (nome) {
        case 'amount':                                 return separa(c, 2, ',', '.');
        case 'amount_no_decimals':                     return separa(c, 0, ',', '');
        case 'amount_with_comma_separator':            return separa(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':return separa(c, 0, '.', '');
        case 'amount_with_apostrophe_separator':       return separa(c, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':return separa(c, 0, ' ', '');
        case 'amount_with_space_separator':            return separa(c, 2, ' ', ',');
        default:                                       return separa(c, 2, '.', ',');
      }
    });
  }

  /* ---------------------------------------------------------------------
     IL TEMPO RISERVATO
     Il vecchio cassetto teneva il carrello "riservato per 5 minuti". La
     scadenza sta in sessionStorage: chiudendo e riaprendo il cassetto il
     conto NON riparte da capo, se no non sarebbe una riserva ma un
     orologio finto. Il battito vive solo a cassetto aperto.
     --------------------------------------------------------------------- */
  function leggiScadenza() {
    try { return parseInt(sessionStorage.getItem(CHIAVE_SCADENZA), 10) || 0; }
    catch (e) { return 0; }
  }

  function scriviScadenza(v) {
    try { if (v) { sessionStorage.setItem(CHIAVE_SCADENZA, String(v)); }
          else   { sessionStorage.removeItem(CHIAVE_SCADENZA); } }
    catch (e) {}
  }

  function disegnaTempo() {
    if (!fasciaTimer || !oraTimer) return;
    var restano = leggiScadenza() - Date.now();
    if (restano <= 0) { fermaTimer(); return; }
    var s = Math.floor(restano / 1000);
    var m = Math.floor(s / 60);
    oraTimer.textContent = (m < 10 ? '0' : '') + m + ':' + ((s % 60) < 10 ? '0' : '') + (s % 60);
  }

  function fermaTimer() {
    if (battito) { clearInterval(battito); battito = null; }
    if (fasciaTimer) fasciaTimer.hidden = true;
  }

  function avviaTimer(pieno) {
    if (!fasciaTimer) return;
    if (!pieno) { fermaTimer(); scriviScadenza(0); return; }
    if (!leggiScadenza() || leggiScadenza() <= Date.now()) scriviScadenza(Date.now() + MINUTI);
    fasciaTimer.hidden = false;
    disegnaTempo();
    if (!battito) battito = setInterval(disegnaTempo, 1000);
  }

  function apri() {
    if (timerChiusura) { clearTimeout(timerChiusura); timerChiusura = null; }
    ultimoFuoco = document.activeElement;
    velo.hidden = false; cassetto.hidden = false;
    void cassetto.offsetWidth;            /* forza il reflow: la transizione parte */
    velo.classList.add('aperto');
    cassetto.classList.add('aperto');
    document.body.style.overflow = 'hidden';
    avviaTimer(!piede.hidden);            /* il piede e' visibile solo col carrello pieno */
    var x = cassetto.querySelector('[data-cassetto-chiudi]');
    if (x) x.focus();
  }

  function chiudi() {
    velo.classList.remove('aperto'); cassetto.classList.remove('aperto');
    document.body.style.overflow = '';
    if (battito) { clearInterval(battito); battito = null; }   /* niente battito a cassetto chiuso */
    timerChiusura = setTimeout(function () {
      velo.hidden = true; cassetto.hidden = true; timerChiusura = null;
    }, 380);
    if (ultimoFuoco && ultimoFuoco.focus) ultimoFuoco.focus();
  }

  function aggiornaConta(n) {
    var e = document.querySelector('[data-conta]');
    if (e) {
      e.textContent = n;
      if (n > 0) { e.removeAttribute('hidden'); } else { e.setAttribute('hidden', ''); }
    }
    /* "Carrello • 3 prodotti", come nel vecchio tema */
    if (contaTesta && contaN && contaParola) {
      contaN.textContent = n;
      contaParola.textContent = n === 1 ? T('cassettoProdotto', 'prodotto') : T('cassettoProdotti', 'prodotti');
      contaTesta.hidden = n <= 0;
    }
  }

  function disegna(c) {
    aggiornaConta(c.item_count);
    if (!c.items || !c.items.length) {
      corpo.innerHTML = '<p class="cassetto-vuoto">' + T('carrelloVuoto', 'Il carrello è vuoto.') + '</p>';
      piede.hidden = true;
      fermaTimer(); scriviScadenza(0);   /* carrello vuoto: non c'e' niente da riservare */
      return;
    }

    corpo.innerHTML = c.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var variante = (i.variant_title && i.variant_title !== 'Default Title')
        ? '<p class="cassetto-var">' + esc(i.variant_title) + '</p>' : '';

      /* Il prezzo pieno barrato e il risparmio della riga. Gli sconti dei
         pacchetti Kaching sono sconti automatici di Shopify: arrivano gia'
         calcolati dentro /cart.js, non serve leggerli dall'app. */
      var scontata = i.original_line_price > i.final_line_price;
      var pieno = scontata ? '<s class="cassetto-prezzo-pieno">' + soldi(i.original_line_price) + '</s> ' : '';
      var quantoRisparmia = '';
      if (scontata) {
        var alloc = i.line_level_discount_allocations && i.line_level_discount_allocations[0];
        var nome = (alloc && alloc.discount_application && alloc.discount_application.title) || '';
        quantoRisparmia =
          '<p class="cassetto-riga-risparmi">' +
            T('risparmi', 'Risparmi') + ' ' + soldi(i.original_line_price - i.final_line_price) +
            (nome ? ' <span>' + esc(nome) + '</span>' : '') +
          '</p>';
      }

      return '<div class="cassetto-riga" data-chiave="' + esc(i.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="160" height="160" loading="lazy">' : '<span></span>') +
        '<div>' +
          '<div class="cassetto-riga-alto">' +
            '<p class="cassetto-nome">' + esc(i.product_title) + '</p>' +
            '<button type="button" class="cassetto-togli" data-togli aria-label="' +
              attr(T('cassettoRimuovi', 'Rimuovi')) + '">&#10005;</button>' +
          '</div>' +
          variante +
          '<div class="cassetto-riga-basso">' +
            '<span class="cassetto-qta">' +
              '<button type="button" data-riga="-" aria-label="' + attr(T('togliUno', 'Togli uno')) + '">&minus;</button>' +
              '<span>' + i.quantity + '</span>' +
              '<button type="button" data-riga="+" aria-label="' + attr(T('aggiungiUno', 'Aggiungi uno')) + '">+</button>' +
            '</span>' +
            '<span class="cassetto-prezzo">' + pieno + soldi(i.final_line_price) + '</span>' +
          '</div>' +
          quantoRisparmia +
        '</div>' +
      '</div>';
    }).join('');

    totale.textContent = soldi(c.total_price);

    /* Il risparmio complessivo, sopra il totale */
    if (risparmi && risparmiVal) {
      if (c.total_discount > 0) {
        risparmiVal.textContent = '-' + soldi(c.total_discount);
        risparmi.hidden = false;
      } else {
        risparmi.hidden = true;
      }
    }

    /* Il prezzo dentro il pulsante di pagamento */
    if (pagaPrezzo) pagaPrezzo.textContent = soldi(c.total_price);

    piede.hidden = false;
    if (!cassetto.hidden) avviaTimer(true);
  }

  function leggi(apriDopo) {
    return fetch(radice() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { disegna(c); if (apriDopo) apri(); return c; })
      .catch(function () {});
  }

  function cambia(chiave, quantita) {
    return fetch(radice() + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: chiave, quantity: Math.max(0, quantita) })
    }).then(function (r) { return r.json(); }).then(disegna);
  }

  document.addEventListener('click', function (e) {
    var c = e.target.closest('.carrello');
    if (c) { e.preventDefault(); leggi(true); return; }

    if (e.target.closest('[data-cassetto-chiudi]') || e.target.closest('[data-cassetto-velo]')) {
      chiudi(); return;
    }

    /* la X della riga: toglie tutto il prodotto, non uno alla volta */
    var x = e.target.closest('[data-togli]');
    if (x) {
      var rigaX = x.closest('[data-chiave]');
      if (rigaX) cambia(rigaX.dataset.chiave, 0);
      return;
    }

    var b = e.target.closest('[data-riga]');
    if (b) {
      var riga = b.closest('[data-chiave]');
      var span = riga.querySelector('.cassetto-qta span');
      var q = parseInt(span.textContent, 10) || 1;
      cambia(riga.dataset.chiave, b.dataset.riga === '+' ? q + 1 : q - 1);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !cassetto.hidden) chiudi();
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var b = f.querySelector('[name="add"]');
    var testo = b ? b.innerHTML : '';
    if (b) { b.disabled = true; b.innerHTML = '<span>' + T('aggiungo', 'Aggiungo…') + '</span>'; }
    fetch(radice() + 'cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) { return r.json(); })
      .then(function () { return leggi(true); })
      .catch(function () { f.submit(); })
      .then(function () { if (b) { b.disabled = false; b.innerHTML = testo; } });
  });

  scriviEtichette();
  leggi(false);
})();
